export const GO_BUTTON_FOR_GENERIC_SALE_ACTION = 'GO_BUTTON_FOR_GENERIC_SALE_ACTION'
export const GO_BUTTON_FOR_GENERIC_SALE_SUCCESS = 'GO_BUTTON_FOR_GENERIC_SALE_SUCCESS'
